import React, { Component } from "react";
import AddRound from "../../images/add_round.svg";
import AddRoundDisabled from "../../images/add_round_gray.svg";
import DelRound from "../../images/del_round.svg";
import DelRoundDisabled from "../../images/del_round_gray.svg";
import "./counter.scss";

export default class CouterConponent extends Component {
    state = {
        minCount: 1,
        maxCount: 5
    }
    constructor(props) {
        super(props);
        const { init } = props;
        if(init) {
            init(this.setCounterState);
        }
    }

    onDecresment = () => {
        const { minCount } = this.state;
        const { counter } = this.props;
        const count = counter -1;
        if(count >= minCount) {
            this.setCounter(count);
        } 
    }

    onIncresment = () => {
        const { maxCount } = this.state;
        const { counter } = this.props;
        const count = counter + 1;
        if (count <= maxCount) {
            this.setCounter(count);
        }
    };

    setCounter(counter) {
        if (this.props.onChange) {
            this.props.onChange(counter);
        }
    }

    setCounterState = (props) => {
        this.setState({...this.state, ...props });
    }

    render() {
        const { minCount, maxCount }   = this.state;
        const { className, counter } = this.props;

        const addIcon = counter < maxCount ? AddRound : AddRoundDisabled;
        const delIcon = counter > minCount ? DelRound : DelRoundDisabled;

        return (
            <div className={`counter d-flex align-item-center ${className}`}>
                <div onClick={this.onDecresment}>
                    <IconCounter icon={delIcon} />
                </div>
                <div className="text-counter-value text-dark-blue">{counter}</div>
                <div onClick={this.onIncresment}>
                    <IconCounter icon={addIcon} />
                </div>
            </div>
        );
    }
}

function IconCounter(props) {
  return <img src={props.icon} width="24px" height="24px" alt="" />;
}
